<template>
  <div>
    <el-empty :description="message"></el-empty>
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>